import request from '@/utils/request'

// 获取热搜词列表
// GET /api/frontend/home/hot-keywords
// 参数:
// - limit: 数量限制 (可选)
export function getHotKeywords(params) {
  return request({
    url: '/api/frontend/home/hot-keywords',
    method: 'get',
    params
  })
}

// 搜索
// GET /api/frontend/home/search
// 参数:
// - keyword: 搜索关键字
// - type: 搜索类型：course-课程，exam-考试，product-商品
// - limit: 每页数量
export function getSearchResult(params) {
  return request({
    url: '/api/frontend/home/search',
    method: 'get',
    params
  })
}
